import { Link } from 'react-router-dom';

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionTo?: string;
  eyebrow?: string;
}

export default function SectionHeader({
  title,
  subtitle,
  actionLabel,
  actionTo,
  eyebrow,
}: SectionHeaderProps) {
  return (
    <div className="mb-5 flex flex-wrap items-end justify-between gap-3 md:mb-6">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 text-[11px] font-medium uppercase tracking-[0.18em] text-accent-600">
            <span className="h-1 w-1 rounded-full bg-accent-500" />
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {subtitle && (
          <p className="mt-1.5 text-xs leading-relaxed text-foreground-500 md:text-sm">{subtitle}</p>
        )}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-accent-600 md:text-sm"
        >
          {actionLabel}
          <i className="ri-arrow-right-s-line text-base" />
        </Link>
      )}
    </div>
  );
}